//import {COUNTRIES, PROVINCES, CITIES, ROLES} from '../constant';

export default {
    state: {
        post: {
            editing: false,
            fetching: false,
            statusOk: null,
            errMessage: "",
            okMessage: "",
            updating: false,
            data: null,
            loading: false,
        },
        files: {
            images: [], videos: []
        },
        images: {
            statusOk: null,
            errMessage: "",
            okMessage: "",
            uploading: false,
            deleting: false
        },
        videos: {
            statusOk: null,
            errMessage: "",
            okMessage: "",
            uploading: false,
            deleting: false
        }
    },
    mutations: {
        'POST_EDITING' (state, val) {
            state.post.editing = val;
        },
        'POST_EDIT_FETCHING' (state, val) {
            state.post.fetching = val;
        },
        'POST_EDIT_FETCHING_SUCCESS' (state, val) {
            state.post.statusOk = true;
            state.post.errMessage = "";
            state.post.data = val;
            state.files.images = val.imageURIs.map(item =>  {return {uri: item}});
            state.files.videos = val.videoURIs.map(item =>  {return {uri: item}});
        },
        'POST_EDIT_FETCHING_ERROR' (state, val) {
            state.post.statusOk = false;
            state.post.errMessage = val;
            state.post.okMessage = "";
        },
        'POST_EDIT_UPDATING' (state, val) {
            state.post.updating = val;
        },
        'POST_EDIT_UPDATING_SUCCESS' (state, val) {
            state.post.statusOk = true;
            state.post.errMessage = "";
            state.post.data = val;
            state.post.okMessage = "Post successfully updated.";
        },
        'POST_EDIT_UPDATING_ERROR' (state, val) {
            state.post.statusOk = false;
            state.post.errMessage = val;
            state.post.okMessage = "";
        },
        'POST_EDIT_DELETING_IMAGE' (state, val) {
            state.images.deleting = val;
        },
        'POST_EDIT_DELETING_IMAGE_SUCCESS' (state, val) {
            state.images.statusOk = true;
            state.images.errMessage = "";
            state.images.okMessage = "Image successfully deleted.";
            state.files.images = val.imageURIs.map(item =>  {return {uri: item}});
        },
        'POST_EDIT_DELETING_IMAGE_ERROR' (state, val) {
            state.images.statusOk = false;
            state.images.errMessage = val;
            state.images.okMessage = "";
        },
        'POST_EDIT_UPLOADING_IMAGE' (state, val) {
            state.images.uploading = val;
        },
        'POST_EDIT_UPLOADING_IMAGE_SUCCESS' (state, val) {
            state.images.statusOk = true;
            state.images.errMessage = "";
            state.images.okMessage = "Image successfully uploaded.";
            state.files.images = val.imageURIs.map(item =>  {return {uri: item}});
        },
        'POST_EDIT_UPLOADING_IMAGE_ERROR' (state, val) {
            state.images.statusOk = false;
            state.images.errMessage = val;
            state.images.okMessage = "";
        },
        'POST_EDIT_DELETING_VIDEO' (state, val) {
            state.videos.deleting = val;
        },
        'POST_EDIT_DELETING_VIDEO_SUCCESS' (state, val) {
            state.videos.statusOk = true;
            state.videos.errMessage = "";
            state.videos.okMessage = "Video successfully deleted.";
            state.files.videos = val.imageURIs.map(item =>  {return {uri: item}});
        },
        'POST_EDIT_DELETING_VIDEO_ERROR' (state, val) {
            state.videos.statusOk = false;
            state.videos.errMessage = val;
            state.videos.okMessage = "";
        },
        'POST_EDIT_UPLOADING_VIDEO' (state, val) {
            state.videos.uploading = val;
        },
        'POST_EDIT_UPLOADING_VIDEO_SUCCESS' (state, val) {
            state.videos.statusOk = true;
            state.videos.errMessage = "";
            state.videos.okMessage = "Video successfully uploaded.";
            state.files.videos = val.imageURIs.map(item =>  {return {uri: item}});
        },
        'POST_EDIT_UPLOADING_VIDEO_ERROR' (state, val) {
            state.videos.statusOk = false;
            state.videos.errMessage = val;
            state.videos.okMessage = "";
        }
    },
    actions: {
        'POST_EDIT_FETCH' ({commit, rootState}, itemID) {
            /* eslint-disable */
            console.log("itemID", itemID);
            commit('POST_EDIT_FETCHING', true);
            //do images and videos upload first
            axios.get(`/item/${itemID}`, {params: {type: "edit"}})
            .then(resp => {
                commit('POST_EDIT_FETCHING', false);
                commit('POST_EDIT_FETCHING_SUCCESS', resp.data.response);
                console.log("posts", resp);
            })
            .catch(err => {
                commit('POST_EDIT_FETCHING', false);
                commit('POST_EDIT_FETCHING_ERROR', rootState.locale === "en" ? 'Error. Post failed to load.':'Error. Lataus epäonnistui.');
                console.log("posts err", err);
            });
        },
        'POST_EDIT_UPDATE'({commit, rootState}, data) {
            /* eslint-disable */
            console.log("data", data);
            commit('POST_EDIT_UPDATING', true);
            //do images and videos upload first
            axios.put(`/item/${data.itemID}`, data.payload)
            .then(resp => {
                commit('POST_EDIT_UPDATING', false);
                commit('POST_EDIT_UPDATING_SUCCESS', resp.data.response);
                commit('POST_EDITING', false);
                console.log("count posts", resp);
            })
            .catch(err => {
                commit('POST_EDIT_UPDATING', false);
                commit('POST_EDIT_UPDATING_ERROR', rootState.locale === "en" ? 'Error. Post failed to update.':'Error. Päivitys epäonnistui.');
                console.log("count posts err", err.response);
            });
        },
        'POST_EDIT_DELETE_IMAGE'({commit, rootState}, data) {
            /* eslint-disable */
            console.log("data", data);
            commit('POST_EDIT_DELETING_IMAGE', true);
            //do images and videos upload first
            axios.delete(`/item/${data.itemID}/file`, {params: data.params})
            .then(resp => {
                commit('POST_EDIT_DELETING_IMAGE', false);
                commit('POST_EDIT_DELETING_IMAGE_SUCCESS', resp.data.response);
                console.log("image upload", resp);
            })
            .catch(err => {
                commit('POST_EDIT_DELETING_IMAGE', false);
                commit('POST_EDIT_DELETING_IMAGE_ERROR', rootState.locale === "en" ? 'Error. Image failed to delete.':'Error. Kuvaa ei voitu poistaa.');
                console.log("image upload err", err.response);
            });
        },
        'POST_EDIT_DELETE_VIDEO'({commit, rootState}, data) {
            /* eslint-disable */
            console.log("data", data);
            commit('POST_EDIT_DELETING_VIDEO', true);
            //do images and videos upload first
            axios.delete(`/item/${data.itemID}/file`, {params: data.params})
            .then(resp => {
                commit('POST_EDIT_DELETING_VIDEO', false);
                commit('POST_EDIT_DELETING_VIDEO_SUCCESS', resp.data.response);
                console.log("video upload", resp);
            })
            .catch(err => {
                commit('POST_EDIT_DELETING_VIDEO', false);
                commit('POST_EDIT_DELETING_VIDEO_ERROR',  rootState.locale === "en" ? 'Error. Video failed to delete.':'Error. Videota ei voitu poistaa.');
                console.log("video upload err", err.response);
            });
        },
        'POST_EDIT_UPLOAD_IMAGE' ({commit, rootState}, data) {
            /* eslint-disable */
            console.log("data", data);
            commit('POST_EDIT_UPLOADING_IMAGE', true);
            //do images and videos upload first
            axios.put(`/item/${data.itemID}/file`, data.payload)
            .then(resp => {
                commit('POST_EDIT_UPLOADING_IMAGE', false);
                commit('POST_EDIT_UPLOADING_IMAGE_SUCCESS', resp.data.response);
                console.log("image upload", resp);
            })
            .catch(err => {
                commit('POST_EDIT_UPLOADING_IMAGE', false);
                commit('POST_EDIT_UPLOADING_IMAGE_ERROR', rootState.locale === "en" ? 'Error. Image failed to upload.':'Error. Kuvaa ei voitu ladata.');
                console.log("image upload err", err);
            });
        },
        'POST_EDIT_UPLOAD_VIDEO' ({commit, rootState}, data) {
            /* eslint-disable */
            console.log("data", data);
            commit('POST_EDIT_UPLOADING_VIDEO', true);
            //do images and videos upload first
            axios.put(`/item/${data.itemID}/file`, data.payload)
            .then(resp => {
                commit('POST_EDIT_UPLOADING_VIDEO', false);
                commit('POST_EDIT_UPLOADING_VIDEO_SUCCESS', resp.data.response);
                console.log("video upload", resp);
            })
            .catch(err => {
                commit('POST_EDIT_UPLOADING_VIDEO', false);
                commit('POST_EDIT_UPLOADING_VIDEO_ERROR', rootState.locale === "en" ? 'Error. Video failed to upload.':'Error. Videota ei voitu ladata.');
                console.log("video upload err", err);
            });
        }
    }
};